import * as Yup from "yup";

/**
 * Construye los valores iniciales para el formulario,
 * con la posibilidad de setear 'classNumber' por defecto.
 */
export function buildInitialValues(classNumber) {
  return {
    nameRute: "",
    description: "",
    // Si llega un 'classNumber' por props, lo asignamos. Si no, vacío.
    classnumber: classNumber || "",
  };
}

/**
 * Esquema de validaciones con Yup
 */
export function validationSchema() {
  return Yup.object({
    nameRute: Yup.string().required("El nombre de la ruta es obligatorio"),
    description: Yup.string(), // Podrías poner un .required() si deseas
    classnumber: Yup.string().required(
      "Debes seleccionar una clase o proporcionar el número de la clase"
    ),
  });
}
